import { dataSourceIdMap } from "features/data-source/data-source-id-map";
import { DataSourceName } from "features/data-source/data-source.types";

type DataSourceRegistryRecord = {
    id: string;
    name: DataSourceName;
};

export const dataSourceRegistry = {
    "a5-alarms-manual/list/table": {
        id: dataSourceIdMap["DeviceDetailA5AlarmsCauseAndAction"],
        name: "DeviceDetailA5AlarmsCauseAndAction",
    },
    "abnormal-pm-times/table": {
        id: dataSourceIdMap["AbnormalPMTimes_Table"],
        name: "AbnormalPMTimes_Table",
    },
    "activity-timeline/ca-popup": {
        id: dataSourceIdMap["ActivityTimeline_CAPopup"],
        name: "ActivityTimeline_CAPopup",
    },
    "activity-timeline/service-history-pop-up": {
        id: dataSourceIdMap["ActivityTimeline_ServiceHistoryPopUp"],
        name: "ActivityTimeline_ServiceHistoryPopUp",
    },
    "activity-timeline/service-order-sum-bubble": {
        id: dataSourceIdMap["ActivityTimeline_ServiceOrderSumBubble"],
        name: "ActivityTimeline_ServiceOrderSumBubble",
    },
    "activity-timeline/stacked-bar-chart": {
        id: dataSourceIdMap["ActivityTimeline_StackedBarChart"],
        name: "ActivityTimeline_StackedBarChart",
    },
    "agreements-type/device/line-chart": {
        id: dataSourceIdMap["DeviceDetailAgreementProfitability"],
        name: "DeviceDetailAgreementProfitability",
    },
    "agreements-type/line-chart": {
        id: dataSourceIdMap["CriticalAgreements_AgreementTypesLineChart"],
        name: "CriticalAgreements_AgreementTypesLineChart",
    },
    "agv/activity-timeline/ca-popup": {
        id: dataSourceIdMap["AGV_ActivityTimeline_CAPopup"],
        name: "AGV_ActivityTimeline_CAPopup",
    },
    "astronaut-max/activity-timeline/indication": {
        id: dataSourceIdMap["ActivityTimeline_AstronautMax_Indication"],
        name: "ActivityTimeline_AstronautMax_Indication",
    },
    "attention-customers-issue-table": {
        id: dataSourceIdMap["AttentionCustomersIssueTable"],
        name: "AttentionCustomersIssueTable",
    },
    "attention-customers-kpi-chart": {
        id: dataSourceIdMap["AttentionCustomersKpiChart"],
        name: "AttentionCustomersKpiChart",
    },
    "attention-customers-kpi-text": {
        id: dataSourceIdMap["AttentionCustomersKpiText"],
        name: "AttentionCustomersKpiText",
    },
    "attention-customers-table": {
        id: dataSourceIdMap["AttentionCustomersTable"],
        name: "AttentionCustomersTable",
    },
    "average-repair-time-per-agreement/line-chart": {
        id: dataSourceIdMap["AverageRepairTimePerAgreement_LineChart"],
        name: "AverageRepairTimePerAgreement_LineChart",
    },
    "average-repair-time-per-agreement/table": {
        id: dataSourceIdMap["AverageRepairTimePerAgreement_Table"],
        name: "AverageRepairTimePerAgreement_Table",
    },
    "average-repair-time-per-device/line-chart": {
        id: dataSourceIdMap["AverageRepairTimePerDevice_LineChart"],
        name: "AverageRepairTimePerDevice_LineChart",
    },
    "average-repair-time-per-device/table": {
        id: dataSourceIdMap["AverageRepairTimePerDevice_Table"],
        name: "AverageRepairTimePerDevice_Table",
    },
    "avg-time-pm-technician-chart": {
        id: dataSourceIdMap["AvgTimePMTechnician_Chart"],
        name: "AvgTimePMTechnician_Chart",
    },
    "avg-time-pm-technician-text": {
        id: dataSourceIdMap["AvgTimePMTechnician_Text"],
        name: "AvgTimePMTechnician_Text",
    },
    "avg-time-repair-technician-chart": {
        id: dataSourceIdMap["AvgTimeRepairTechnician_Chart"],
        name: "AvgTimeRepairTechnician_Chart",
    },
    "avg-time-repair-technician-text": {
        id: dataSourceIdMap["AvgTimeRepairTechnician_Text"],
        name: "AvgTimeRepairTechnician_Text",
    },
    "business-improvement": {
        id: dataSourceIdMap["BusinessImprovement"],
        name: "BusinessImprovement",
    },
    "care-check/advice-report-kpi": {
        id: dataSourceIdMap["CareCheck_AdviceReportKpi"],
        name: "CareCheck_AdviceReportKpi",
    },
    "cleaning-performance/alarms-overview": {
        id: dataSourceIdMap["CleaningPerformance_AlarmsOverview"],
        name: "CleaningPerformance_AlarmsOverview",
    },
    "cleaning-performance/alkaline-to-acid-ratio-kpi": {
        id: dataSourceIdMap["CleaningPerformance_AlkalineToAcidRatioKPI"],
        name: "CleaningPerformance_AlkalineToAcidRatioKPI",
    },
    "cleaning-performance/average-number-of-cleanings-kpi": {
        id: dataSourceIdMap["CleaningPerformance_AverageNumberOfCleaningsKPI"],
        name: "CleaningPerformance_AverageNumberOfCleaningsKPI",
    },
    "cleaning-performance/cleaning-alarm-timeline/ca-popup": {
        id: dataSourceIdMap["CleaningPerformance_CleaningAlarmTimeline_CAPopup"],
        name: "CleaningPerformance_CleaningAlarmTimeline_CAPopup",
    },
    "cleaning-performance/cleaning-alarm-timeline/stacked-bar-chart": {
        id: dataSourceIdMap["CleaningPerformance_CleaningAlarmTimeline_StackedBarChart"],
        name: "CleaningPerformance_CleaningAlarmTimeline_StackedBarChart",
    },
    "cleaning-performance/device-select": {
        id: dataSourceIdMap["CleaningPerformance_CleaningAlarmTimeline_LdnDropdown"],
        name: "CleaningPerformance_CleaningAlarmTimeline_LdnDropdown",
    },
    "cleaning-performance/interval-variability-kpi": {
        id: dataSourceIdMap["CleaningPerformance_IntervalVariabilityKPI"],
        name: "CleaningPerformance_IntervalVariabilityKPI",
    },
    "cm/device/status/table": {
        id: dataSourceIdMap["CM_Device_Status_Table"],
        name: "CM_Device_Status_Table",
    },
    "connection-performance/average-connection-attempts-per-day": {
        id: dataSourceIdMap["ConnectionPerformance_AverageConnectionAttemptsPerDay"],
        name: "ConnectionPerformance_AverageConnectionAttemptsPerDay",
    },
    "connection-performance/average-connection-attempts-per-day-target": {
        id: dataSourceIdMap["ConnectionPerformance_AverageConnectionAttemptsPerDayTarget"],
        name: "ConnectionPerformance_AverageConnectionAttemptsPerDayTarget",
    },
    "connection-performance/average-connection-time-per-day": {
        id: dataSourceIdMap["ConnectionPerformance_AverageConnectionTimePerDay"],
        name: "ConnectionPerformance_AverageConnectionTimePerDay",
    },
    "connection-performance/average-connection-time-per-day-target": {
        id: dataSourceIdMap["ConnectionPerformance_AverageConnectionTimePerDayTarget"],
        name: "ConnectionPerformance_AverageConnectionTimePerDayTarget",
    },
    "connection-performance/average-first-time-right-per-day": {
        id: dataSourceIdMap["ConnectionPerformance_AverageFirstTimeRightPerDay"],
        name: "ConnectionPerformance_AverageFirstTimeRightPerDay",
    },
    "connection-performance/average-first-time-right-per-day-target": {
        id: dataSourceIdMap["ConnectionPerformance_AverageFirstTimeRightPerDayTarget"],
        name: "ConnectionPerformance_AverageFirstTimeRightPerDayTarget",
    },
    "connection-performance/average-scans-per-day": {
        id: dataSourceIdMap["ConnectionPerformance_AverageScansPerDay"],
        name: "ConnectionPerformance_AverageScansPerDay",
    },
    "connection-performance/device-list": {
        id: dataSourceIdMap["ConnectionPerformance_DeviceList"],
        name: "ConnectionPerformance_DeviceList",
    },
    "connection-performance/eng/astronaut-type-list": {
        id: dataSourceIdMap["ConnectionPerformance_ENG_AstronautTypeList"],
        name: "ConnectionPerformance_ENG_AstronautTypeList",
    },
    "connection-performance/eng/average-connection-attempts-per-day": {
        id: dataSourceIdMap["ConnectionPerformance_ENG_AverageConnectionAttemptsPerDay"],
        name: "ConnectionPerformance_ENG_AverageConnectionAttemptsPerDay",
    },
    "connection-performance/eng/average-connection-time-per-day": {
        id: dataSourceIdMap["ConnectionPerformance_ENG_AverageConnectionTimePerDay"],
        name: "ConnectionPerformance_ENG_AverageConnectionTimePerDay",
    },
    "connection-performance/eng/average-first-time-right-per-day": {
        id: dataSourceIdMap["ConnectionPerformance_ENG_AverageFirstTimeRightPerDay"],
        name: "ConnectionPerformance_ENG_AverageFirstTimeRightPerDay",
    },
    "connection-performance/eng/average-scans-per-day": {
        id: dataSourceIdMap["ConnectionPerformance_ENG_AverageScansPerDay"],
        name: "ConnectionPerformance_ENG_AverageScansPerDay",
    },
    "connection-performance/eng/country-list": {
        id: dataSourceIdMap["ConnectionPerformance_ENG_CountryList"],
        name: "ConnectionPerformance_ENG_CountryList",
    },
    "connection-performance/eng/failed-milking-reasons-per-day": {
        id: dataSourceIdMap["ConnectionPerformance_ENG_FailedMilkingReasonsPerDay"],
        name: "ConnectionPerformance_ENG_FailedMilkingReasonsPerDay",
    },
    "connection-performance/eng/kpi-chart": {
        id: dataSourceIdMap["ConnectionPerformance_ENG_KPIChart"],
        name: "ConnectionPerformance_ENG_KPIChart",
    },
    "connection-performance/eng/kpi-text": {
        id: dataSourceIdMap["ConnectionPerformance_ENG_KPIText"],
        name: "ConnectionPerformance_ENG_KPIText",
    },
    "connection-performance/eng/software-version-list": {
        id: dataSourceIdMap["ConnectionPerformance_ENG_SoftwareVersionList"],
        name: "ConnectionPerformance_ENG_SoftwareVersionList",
    },
    "connection-performance/failed-milking-reasons-per-day": {
        id: dataSourceIdMap["ConnectionPerformance_FailedMilkingReasonsPerDay"],
        name: "ConnectionPerformance_FailedMilkingReasonsPerDay",
    },
    "connection-performance/failed-milking-reasons-per-day-target": {
        id: dataSourceIdMap["ConnectionPerformance_FailedMilkingReasonsPerDayTarget"],
        name: "ConnectionPerformance_FailedMilkingReasonsPerDayTarget",
    },
    "connection-performance/failed-milkings-per-day-target": {
        id: dataSourceIdMap["ConnectionPerformance_FailedMilkingsPerDayTarget"],
        name: "ConnectionPerformance_FailedMilkingsPerDayTarget",
    },
    "connection-performance/farm-list": {
        id: dataSourceIdMap["ConnectionPerformance_FarmList"],
        name: "ConnectionPerformance_FarmList",
    },
    "connection-performance/kpi-chart": {
        id: dataSourceIdMap["ConnectionPerformance_KPIChart"],
        name: "ConnectionPerformance_KPIChart",
    },
    "connection-performance/kpi-text": {
        id: dataSourceIdMap["ConnectionPerformance_KPIText"],
        name: "ConnectionPerformance_KPIText",
    },
    "consumables/order-history/table": {
        id: dataSourceIdMap["AllConsumablesOrderHistory_Table"],
        name: "AllConsumablesOrderHistory_Table",
    },
    "consumables/standard-astronaut-orders/table": {
        id: dataSourceIdMap["StandardAstronautOrders_Table"],
        name: "StandardAstronautOrders_Table",
    },
    "consumables/upsell-orders/table": {
        id: dataSourceIdMap["Consumables_UpsellOrders_Table"],
        name: "Consumables_UpsellOrders_Table",
    },
    "critical-agreements/info": {
        id: dataSourceIdMap["CriticalAgreements_Info"],
        name: "CriticalAgreements_Info",
    },
    "critical-agreements/kpi-chart": {
        id: dataSourceIdMap["CriticalAgreements_KPIChart"],
        name: "CriticalAgreements_KPIChart",
    },
    "critical-agreements/kpi-text": {
        id: dataSourceIdMap["CriticalAgreements_KPIText"],
        name: "CriticalAgreements_KPIText",
    },
    "critical-agreements/table": {
        id: dataSourceIdMap["CriticalAgreements_Table"],
        name: "CriticalAgreements_Table",
    },
    "critical-alarms/critical-alarms-overview": {
        id: dataSourceIdMap["CriticalAlarms_CriticalAlarmsOverview"],
        name: "CriticalAlarms_CriticalAlarmsOverview",
    },
    "critical-alarms/critical-alarm-timeline/ca-popup": {
        id: dataSourceIdMap["CriticalAlarms_CriticalAlarmsTimeline_CAPopup"],
        name: "CriticalAlarms_CriticalAlarmsTimeline_CAPopup",
    },
    "critical-alarms/critical-alarm-timeline/stacked-bar-chart": {
        id: dataSourceIdMap["CriticalAlarms_CriticalAlarmsTimeline_StackedBarChart"],
        name: "CriticalAlarms_CriticalAlarmsTimeline_StackedBarChart",
    },
    "critical-alarms/device-select": {
        id: dataSourceIdMap["CriticalAlarms_CriticalAlarmsTimeline_DeviceDropdown"],
        name: "CriticalAlarms_CriticalAlarmsTimeline_DeviceDropdown",
    },
    "critical-alarms-analysis/agv-alarm-description-select": {
        id: dataSourceIdMap["CriticalAlarmsAnalysis_AgvAlarmDescriptionSelect"],
        name: "CriticalAlarmsAnalysis_AgvAlarmDescriptionSelect",
    },
    "critical-alarms-analysis/agv-alarm-occurence": {
        id: dataSourceIdMap["CriticalAlarmsAnalysis_AgvAlarmOccurence"],
        name: "CriticalAlarmsAnalysis_AgvAlarmOccurence",
    },
    "critical-alarms-analysis/agv-highest-counts": {
        id: dataSourceIdMap["CriticalAlarmsAnalysis_AgvHighestCounts"],
        name: "CriticalAlarmsAnalysis_AgvHighestCounts",
    },
    "critical-alarms-analysis/astronaut-agreement-type-select": {
        id: dataSourceIdMap["CriticalAlarmsAnalysis_AstronautAgreementType_SelectWidget"],
        name: "CriticalAlarmsAnalysis_AstronautAgreementType_SelectWidget",
    },
    "critical-alarms-analysis/astronaut-alarm-description-select": {
        id: dataSourceIdMap["CriticalAlarmsAnalysis_AstronautAlarmDescription_SelectWidget"],
        name: "CriticalAlarmsAnalysis_AstronautAlarmDescription_SelectWidget",
    },
    "critical-alarms-analysis/astronaut-alarm-occurence": {
        id: dataSourceIdMap["CriticalAlarmsAnalysis_AstronautAlarmOccurence"],
        name: "CriticalAlarmsAnalysis_AstronautAlarmOccurence",
    },
    "critical-alarms-analysis/astronaut-device-type-select": {
        id: dataSourceIdMap["CriticalAlarmsAnalysis_AstronautDeviceType_SelectWidget"],
        name: "CriticalAlarmsAnalysis_AstronautDeviceType_SelectWidget",
    },
    "critical-alarms-analysis/astronaut-highest-counts": {
        id: dataSourceIdMap["CriticalAlarmsAnalysis_AstronautHighestCounts"],
        name: "CriticalAlarmsAnalysis_AstronautHighestCounts",
    },
    "critical-alarms-analysis/astronaut-software-version-select": {
        id: dataSourceIdMap["CriticalAlarmsAnalysis_AstronautSoftwareVersion_SelectWidget"],
        name: "CriticalAlarmsAnalysis_AstronautSoftwareVersion_SelectWidget",
    },
    "critical-alarms-analysis/vector-alarm-description-select": {
        id: dataSourceIdMap["CriticalAlarmsAnalysis_VectorAlarmDescription_SelectWidget"],
        name: "CriticalAlarmsAnalysis_VectorAlarmDescription_SelectWidget",
    },
    "critical-alarms-analysis/vector-alarm-occurence": {
        id: dataSourceIdMap["CriticalAlarmsAnalysis_VectorAlarmOccurence"],
        name: "CriticalAlarmsAnalysis_VectorAlarmOccurence",
    },
    "critical-alarms-analysis/vector-device-type-select": {
        id: dataSourceIdMap["CriticalAlarmsAnalysis_VectorDeviceType_SelectWidget"],
        name: "CriticalAlarmsAnalysis_VectorDeviceType_SelectWidget",
    },
    "critical-alarms-analysis/vector-highest-counts": {
        id: dataSourceIdMap["CriticalAlarmsAnalysis_VectorHighestCounts"],
        name: "CriticalAlarmsAnalysis_VectorHighestCounts",
    },
    "customer-detail/cleaning-alarms-kpi": {
        id: dataSourceIdMap["CustomerDetailKPI_CleaningAlarms_Chart"],
        name: "CustomerDetailKPI_CleaningAlarms_Chart",
    },
    "customer-detail/compressor": {
        id: dataSourceIdMap["CustomerDetail_Compressor"],
        name: "CustomerDetail_Compressor",
    },
    "customer-detail/critical-alarm-kpi": {
        id: dataSourceIdMap["CustomerDetailKPI_CriticalAlarms_Chart"],
        name: "CustomerDetailKPI_CriticalAlarms_Chart",
    },
    "customer-detail/critical-and-cleaning-alarms/text": {
        id: dataSourceIdMap["CustomerDetailKPI_Alarms_Text"],
        name: "CustomerDetailKPI_Alarms_Text",
    },
    "customer-detail/fms/bimodal-cow-kpi-chart": {
        id: dataSourceIdMap["CustomerDetail_FMS_BimodalCowKPIChart"],
        name: "CustomerDetail_FMS_BimodalCowKPIChart",
    },
    "customer-detail/fms/bimodal-cow-kpi-text": {
        id: dataSourceIdMap["CustomerDetail_FMS_BimodalCowKPIText"],
        name: "CustomerDetail_FMS_BimodalCowKPIText",
    },
    "customer-detail/fms/feeding/feed-stuff-overview": {
        id: dataSourceIdMap["VectorLoadingPerformance_Feeding_FeedStuffOverview"],
        name: "VectorLoadingPerformance_Feeding_FeedStuffOverview",
    },
    "customer-detail/fms/feeding/kpi-evolution-feed-stuff": {
        id: dataSourceIdMap["CustomerDetail_FMS_Feeding_KpiEvolutionFeedStuff"],
        name: "CustomerDetail_FMS_Feeding_KpiEvolutionFeedStuff",
    },
    "customer-detail/fms/feeding/system-ldn-list": {
        id: dataSourceIdMap["VectorLoadingPerformance_Feeding_SystemLdnList"],
        name: "VectorLoadingPerformance_Feeding_SystemLdnList",
    },
    "customer-detail/fms/feeding/top5-vector-system-failures": {
        id: dataSourceIdMap["CustomerDetail_FMS_Feeding_Top5VectorSystemFailures"],
        name: "CustomerDetail_FMS_Feeding_Top5VectorSystemFailures",
    },
    "customer-detail/fms/feeding-overview/kpi-chart": {
        id: dataSourceIdMap["CustomerDetail_FMS_FeedingOverview_KPIChart"],
        name: "CustomerDetail_FMS_FeedingOverview_KPIChart",
    },
    "customer-detail/fms/feeding-overview/kpi-text": {
        id: dataSourceIdMap["CustomerDetail_FMS_FeedingOverview_KPIText"],
        name: "CustomerDetail_FMS_FeedingOverview_KPIText",
    },
    "customer-detail/fms/installed-devices": {
        id: dataSourceIdMap["CustomerDetail_FMS_InstalledDevices"],
        name: "CustomerDetail_FMS_InstalledDevices",
    },
    "customer-detail/fms/milking-overview/kpi-chart": {
        id: dataSourceIdMap["CustomerDetail_FMS_MilkingOverview_KPIChart"],
        name: "CustomerDetail_FMS_MilkingOverview_KPIChart",
    },
    "customer-detail/fms/milking-overview/kpi-text": {
        id: dataSourceIdMap["CustomerDetail_FMS_MilkingOverview_KPIText"],
        name: "CustomerDetail_FMS_MilkingOverview_KPIText",
    },
    "customer-detail/fms/service-history-customer": {
        id: dataSourceIdMap["CustomerDetail_FMS_ServiceHistoryCustomer"],
        name: "CustomerDetail_FMS_ServiceHistoryCustomer",
    },
    "customer-detail/fms/somatic-cell-count/kpi-chart": {
        id: dataSourceIdMap["CustomerDetail_FMS_SomaticCellCount_KPIChart"],
        name: "CustomerDetail_FMS_SomaticCellCount_KPIChart",
    },
    "customer-detail/fms/somatic-cell-count/kpi-text": {
        id: dataSourceIdMap["CustomerDetail_FMS_SomaticCellCount_KPIText"],
        name: "CustomerDetail_FMS_SomaticCellCount_KPIText",
    },
    "customer-detail/map-link": {
        id: dataSourceIdMap["CustomerDetail_MapLink"],
        name: "CustomerDetail_MapLink",
    },
    "customer-detail": {
        id: dataSourceIdMap["CustomerDetail"],
        name: "CustomerDetail",
    },
    "customer-detail-kpi/chart/extended": {
        id: dataSourceIdMap["CustomerDetailKPI_Chart_Extended"],
        name: "CustomerDetailKPI_Chart_Extended",
    },
    "customer-detail-kpi/chart": {
        id: dataSourceIdMap["CustomerDetailKPI_Chart"],
        name: "CustomerDetailKPI_Chart",
    },
    "customer-detail-kpi/extended": {
        id: dataSourceIdMap["CustomerDetailKPI_Extended"],
        name: "CustomerDetailKPI_Extended",
    },
    "customer-detail-kpi/failed-milkings/text": {
        id: dataSourceIdMap["CustomerDetailKPI_MilkProduction_Text"],
        name: "CustomerDetailKPI_MilkProduction_Text",
    },
    "customer-detail-kpi/milking-since-installation/text": {
        id: dataSourceIdMap["CustomerDetailKPI_MilkingSinceInstallation_Text"],
        name: "CustomerDetailKPI_MilkingSinceInstallation_Text",
    },
    "customer-detail-kpi/milking-since-last-pm/chart": {
        id: dataSourceIdMap["CustomerDetailKPI_MilkingSinceLastPM_Chart"],
        name: "CustomerDetailKPI_MilkingSinceLastPM_Chart",
    },
    "customer-detail-kpi/milk-production/chart": {
        id: dataSourceIdMap["CustomerDetailKPI_MilkProduction_Chart"],
        name: "CustomerDetailKPI_MilkProduction_Chart",
    },
    "customer-detail-kpi-chart": {
        id: dataSourceIdMap["CustomerDetailKPIChart"],
        name: "CustomerDetailKPIChart",
    },
    "customer-detail-kpi-text": {
        id: dataSourceIdMap["CustomerDetailKPIText"],
        name: "CustomerDetailKPIText",
    },
    "dashboard/critical-alarms/chart": {
        id: dataSourceIdMap["Dashboard_CriticalAlarmsPerAstronautPast12Months_Chart"],
        name: "Dashboard_CriticalAlarmsPerAstronautPast12Months_Chart",
    },
    "dashboard/repairs-per-astronaut-past12-months/kpi/chart": {
        id: dataSourceIdMap["Dashboard_RepairsPerAstronautPast12Months_KPI_Chart"],
        name: "Dashboard_RepairsPerAstronautPast12Months_KPI_Chart",
    },
    "dashboard/repairs-per-astronaut-past12-months/kpi/text": {
        id: dataSourceIdMap["Dashboard_RepairsPerAstronautPast12Months_KPI_Text"],
        name: "Dashboard_RepairsPerAstronautPast12Months_KPI_Text",
    },
    "dashboard/repairs-pms-ratio/chart": {
        id: dataSourceIdMap["Dashboard_RepairsPMsRatio_Chart"],
        name: "Dashboard_RepairsPMsRatio_Chart",
    },
    "dashboard/reports-per-device/chart": {
        id: dataSourceIdMap["Dashboard_ReportsPerDevice_Chart"],
        name: "Dashboard_ReportsPerDevice_Chart",
    },
    "dashboard/reports-per-device/text": {
        id: dataSourceIdMap["Dashboard_ReportsPerDevice_Text"],
        name: "Dashboard_ReportsPerDevice_Text",
    },
    "dashboard/spent-hours/chart": {
        id: dataSourceIdMap["Dashboard_SpentHours_Chart"],
        name: "Dashboard_SpentHours_Chart",
    },
    "dashboard/spent-hours/text": {
        id: dataSourceIdMap["Dashboard_SpentHours_Text"],
        name: "Dashboard_SpentHours_Text",
    },
    "device-compressor/low-air-pressure": {
        id: dataSourceIdMap["DeviceCompressorLowAirPressure"],
        name: "DeviceCompressorLowAirPressure",
    },
    "device-compressor/target": {
        id: dataSourceIdMap["DeviceCompressorTarget"],
        name: "DeviceCompressorTarget",
    },
    "device-compressor": {
        id: dataSourceIdMap["DeviceCompressor"],
        name: "DeviceCompressor",
    },
    "device-compressor-status": {
        id: dataSourceIdMap["DeviceCompressorStatus"],
        name: "DeviceCompressorStatus",
    },
    "device-data-issue": {
        id: dataSourceIdMap["DeviceDataIssue"],
        name: "DeviceDataIssue",
    },
    "device-detail/cm-visualization": {
        id: dataSourceIdMap["DeviceDetailCMVisualization"],
        name: "DeviceDetailCMVisualization",
    },
    "device-details": {
        id: dataSourceIdMap["DeviceDetails"],
        name: "DeviceDetails",
    },
    "device-selector": {
        id: dataSourceIdMap["DeviceSelector"],
        name: "DeviceSelector",
    },
    "devices-table": {
        id: dataSourceIdMap["DevicesTable"],
        name: "DevicesTable",
    },
    "farm-license-active-check": {
        id: dataSourceIdMap["FarmLicenseActiveCheck"],
        name: "FarmLicenseActiveCheck",
    },
    "farm-list": {
        id: dataSourceIdMap["FarmList"],
        name: "FarmList",
    },
    "farm-scan/daily-chart/beta": {
        id: dataSourceIdMap["FarmScan_DailyChart_Beta"],
        name: "FarmScan_DailyChart_Beta",
    },
    "farm-scan/daily-chart": {
        id: dataSourceIdMap["FarmScan_DailyChart"],
        name: "FarmScan_DailyChart",
    },
    "farm-scan/failed-milking-reasons-chart": {
        id: dataSourceIdMap["FarmScan_FailedMilkingReasonsChart"],
        name: "FarmScan_FailedMilkingReasonsChart",
    },
    "farm-scan/farm-detail": {
        id: dataSourceIdMap["FarmScan_FarmDetail"],
        name: "FarmScan_FarmDetail",
    },
    "farm-scan/farm-ranking-within-lely-center": {
        id: dataSourceIdMap["FarmScan_FarmRankingWithinLelyCenter"],
        name: "FarmScan_FarmRankingWithinLelyCenter",
    },
    "farm-scan/has-astronaut-and-or-vector": {
        id: dataSourceIdMap["FarmScan_HasAstronautAndOrVector"],
        name: "FarmScan_HasAstronautAndOrVector",
    },
    "farm-scan/lactation-chart": {
        id: dataSourceIdMap["FarmScan_LactationChart"],
        name: "FarmScan_LactationChart",
    },
    "farm-scan/overview-table/beta": {
        id: dataSourceIdMap["FarmScan_OverviewTable"],
        name: "FarmScan_OverviewTable",
    },
    "farmscan/vector-farm-list/beta": {
        id: dataSourceIdMap["FMSFarmScan_VectorFarmList_Beta"],
        name: "FMSFarmScan_VectorFarmList_Beta",
    },
    "feedback/device-detail/insight": {
        id: dataSourceIdMap["Feedback_DeviceDetail_Insight"],
        name: "Feedback_DeviceDetail_Insight",
    },
    "feeding-critical-alarms/critical-alarms-overview": {
        id: dataSourceIdMap["FMS_FeedingCriticalAlarms_CriticalAlarmsOverview"],
        name: "FMS_FeedingCriticalAlarms_CriticalAlarmsOverview",
    },
    "financial-service-history-customer": {
        id: dataSourceIdMap["FinancialServiceHistoryCustomer"],
        name: "FinancialServiceHistoryCustomer",
    },
    "financial-service-history-device": {
        id: dataSourceIdMap["FinancialServiceHistoryDevice"],
        name: "FinancialServiceHistoryDevice",
    },
    "financial-service-history-technician": {
        id: dataSourceIdMap["FinancialServiceHistoryTechnician"],
        name: "FinancialServiceHistoryTechnician",
    },
    "fms/astronaut-settings/table": {
        id: dataSourceIdMap["FMS_DuringMilking_AstronautSettings_Table"],
        name: "FMS_DuringMilking_AstronautSettings_Table",
    },
    "fms/customer-list": {
        id: dataSourceIdMap["FMS_CustomerList"],
        name: "FMS_CustomerList",
    },
    "fms/dashboard/milking-kpi-overview": {
        id: dataSourceIdMap["FMS_Dashboard_MilkingKpiOverview"],
        name: "FMS_Dashboard_MilkingKpiOverview",
    },
    "fms/dashboard/vector-accuracy-and-free-time/kpi-chart": {
        id: dataSourceIdMap["FMS_Dashboard_VectorAccuracyAndFreeTime_KPIChart"],
        name: "FMS_Dashboard_VectorAccuracyAndFreeTime_KPIChart",
    },
    "fms/dashboard/vector-system-failures/kpi-chart": {
        id: dataSourceIdMap["FMS_Dashboard_VectorCriticalAlarms_KPIChart"],
        name: "FMS_Dashboard_VectorCriticalAlarms_KPIChart",
    },
    "fms/farm-settings/table": {
        id: dataSourceIdMap["FMS_DuringMilking_FarmSettings_Table"],
        name: "FMS_DuringMilking_FarmSettings_Table",
    },
    "fms/milking-subpages/device-list": {
        id: dataSourceIdMap["FMS_MilkingSubpages_DeviceList"],
        name: "FMS_MilkingSubpages_DeviceList",
    },
    "fms/pretreatment/avg-lag-brush-times/line-chart": {
        id: dataSourceIdMap["FMS_Pretreatment_AvgLagBrushTimes_LineChart"],
        name: "FMS_Pretreatment_AvgLagBrushTimes_LineChart",
    },
    "fms/pretreatment/cows-category-percentage-per-location/chart": {
        id: dataSourceIdMap["FMS_Pretreatment_CowsCategoryPercentagePerLocation_Chart"],
        name: "FMS_Pretreatment_CowsCategoryPercentagePerLocation_Chart",
    },
    "fms/pretreatment/cows-classified/kpi-chart": {
        id: dataSourceIdMap["FMS_Pretreatment_CowsClassified_KPIChart"],
        name: "FMS_Pretreatment_CowsClassified_KPIChart",
    },
    "fms/pretreatment/cows-in-category-per-lactation-stage/chart": {
        id: dataSourceIdMap["FMS_Pretreatment_CowsInCategoryPerLactationStage_Chart"],
        name: "FMS_Pretreatment_CowsInCategoryPerLactationStage_Chart",
    },
    "fms/pretreatment/cows-in-category-per-milk-interval/chart": {
        id: dataSourceIdMap["FMS_Pretreatment_CowsInCategoryPerMilkInterval_Chart"],
        name: "FMS_Pretreatment_CowsInCategoryPerMilkInterval_Chart",
    },
    "fms/pretreatment/cows-per-bimodal-category/chart": {
        id: dataSourceIdMap["FMS_Pretreatment_CowsPerBimodalCategory_Chart"],
        name: "FMS_Pretreatment_CowsPerBimodalCategory_Chart",
    },
    "fms/pretreatment/overview/table": {
        id: dataSourceIdMap["FMS_Pretreatment_Overview_Table"],
        name: "FMS_Pretreatment_Overview_Table",
    },
    "fms/pretreatment/time-per-bimodal-category/chart": {
        id: dataSourceIdMap["FMS_Pretreatment_TimePerBimodalCategory_Chart"],
        name: "FMS_Pretreatment_TimePerBimodalCategory_Chart",
    },
    "fms/take-off-reason/alerts": {
        id: dataSourceIdMap["FMS_TakeOffReason_Alerts"],
        name: "FMS_TakeOffReason_Alerts",
    },
    "fms/take-off-reason/device/air-flow-per-teat/daily": {
        id: dataSourceIdMap["FMS_TakeOffReason_Device_AirFlowPerTeat_Daily"],
        name: "FMS_TakeOffReason_Device_AirFlowPerTeat_Daily",
    },
    "fms/take-off-reason/device/end-of-milk-flow-per-teat/daily": {
        id: dataSourceIdMap["FMS_TakeOffReason_Device_EndOfMilkFlowPerTeat_Daily"],
        name: "FMS_TakeOffReason_Device_EndOfMilkFlowPerTeat_Daily",
    },
    "fms/take-off-reason/types-distribution/daily": {
        id: dataSourceIdMap["FMS_TakeOffReason_TypesDistribution_Daily"],
        name: "FMS_TakeOffReason_TypesDistribution_Daily",
    },
    "fms/take-off-reason/types-distribution": {
        id: dataSourceIdMap["FMS_TakeOffReason_TypesDistribution"],
        name: "FMS_TakeOffReason_TypesDistribution",
    },
    "fms/visit-behavior/average-free-time-percentage-over-time": {
        id: dataSourceIdMap["FMS_VisitBehavior_AverageFreeTimePercentageOverTime"],
        name: "FMS_VisitBehavior_AverageFreeTimePercentageOverTime",
    },
    "horizon-usage/farms-registered-horizon/threshold": {
        id: dataSourceIdMap["HorizonUsage_FarmsRegisteredHorizon_Threshold"],
        name: "HorizonUsage_FarmsRegisteredHorizon_Threshold",
    },
    "horizon-usage/farms-registered-horizon": {
        id: dataSourceIdMap["HorizonUsage_FarmsRegisteredHorizon"],
        name: "HorizonUsage_FarmsRegisteredHorizon",
    },
    "horizon-usage/horizon-customer-overview": {
        id: dataSourceIdMap["HorizonUsage_HorizonCustomerOverview"],
        name: "HorizonUsage_HorizonCustomerOverview",
    },
    "horizon-usage/horizon-package-distribution": {
        id: dataSourceIdMap["HorizonUsage_HorizonPackageDistribution"],
        name: "HorizonUsage_HorizonPackageDistribution",
    },
    "horizon-usage/hotizon-package-distribution/pie-chart": {
        id: dataSourceIdMap["HorizonUsage_HotizonPackageDistribution_PieChart"],
        name: "HorizonUsage_HotizonPackageDistribution_PieChart",
    },
    "insight-response": {
        id: dataSourceIdMap["InsightResponse"],
        name: "InsightResponse",
    },
    "insights/expanded-detail": {
        id: dataSourceIdMap["Insights_ExpandedDetail"],
        name: "Insights_ExpandedDetail",
    },
    "insights/table": {
        id: dataSourceIdMap["Insights_Table"],
        name: "Insights_Table",
    },
    "installed-devices": {
        id: dataSourceIdMap["InstalledDevices"],
        name: "InstalledDevices",
    },
    "kpi-evolution-service-area": {
        id: dataSourceIdMap["KpiEvolutionServiceArea"],
        name: "KpiEvolutionServiceArea",
    },
    "last-import/aadp/alarms": {
        id: dataSourceIdMap["LastImport_AADP_Alarms"],
        name: "LastImport_AADP_Alarms",
    },
    "last-import/aadp/data-mart": {
        id: dataSourceIdMap["LastImport_AADP_DataMart"],
        name: "LastImport_AADP_DataMart",
    },
    "last-import/middleware": {
        id: dataSourceIdMap["LastImport_Middleware"],
        name: "LastImport_Middleware",
    },
    "long-repairs/table": {
        id: dataSourceIdMap["LongRepairs_Table"],
        name: "LongRepairs_Table",
    },
    "mandatory-updates/credited-lines/table": {
        id: dataSourceIdMap["MandatoryUpdates_CreditedLines_Table"],
        name: "MandatoryUpdates_CreditedLines_Table",
    },
    "mandatory-updates/expanded/table": {
        id: dataSourceIdMap["MandatoryUpdates_Expanded_Table"],
        name: "MandatoryUpdates_Expanded_Table",
    },
    "mandatory-updates/kpi-chart": {
        id: dataSourceIdMap["MandatoryUpdates_KPIChart"],
        name: "MandatoryUpdates_KPIChart",
    },
    "mandatory-updates/kpi-text": {
        id: dataSourceIdMap["MandatoryUpdates_KPIText"],
        name: "MandatoryUpdates_KPIText",
    },
    "mandatory-updates/pop-up": {
        id: dataSourceIdMap["MandatoryUpdates_PopUp"],
        name: "MandatoryUpdates_PopUp",
    },
    "mandatory-updates/table": {
        id: dataSourceIdMap["MandatoryUpdates_Table"],
        name: "MandatoryUpdates_Table",
    },
    "mandatory-updates-per-customer/table": {
        id: dataSourceIdMap["MandatoryUpdatesPerCustomer_Table"],
        name: "MandatoryUpdatesPerCustomer_Table",
    },
    "man-hours-high/metrics": {
        id: dataSourceIdMap["ManHoursHigh_Metrics"],
        name: "ManHoursHigh_Metrics",
    },
    "metric/evolution-in-time": {
        id: dataSourceIdMap["Metric_EvolutionInTime"],
        name: "Metric_EvolutionInTime",
    },
    "milking/alarm-timeline/service-history-pop-up": {
        id: dataSourceIdMap["FMS_AlarmsTimeline_ServiceHistoryPopUp"],
        name: "FMS_AlarmsTimeline_ServiceHistoryPopUp",
    },
    "milking/alarm-timeline/service-order-sum-bubble": {
        id: dataSourceIdMap["FMS_AlarmsTimeline_ServiceOrderSumBubble"],
        name: "FMS_AlarmsTimeline_ServiceOrderSumBubble",
    },
    "milking-cleaning-performance/cleaning-alarms-overview": {
        id: dataSourceIdMap["FMS_CleaningPerformance_CleaningAlarmOverview"],
        name: "FMS_CleaningPerformance_CleaningAlarmOverview",
    },
    "milking-cleaning-performance/cleaning-alarm-timeline/ca-popup": {
        id: dataSourceIdMap["FMS_CleaningPerformance_CleaningAlarmTimeline_CAPopup"],
        name: "FMS_CleaningPerformance_CleaningAlarmTimeline_CAPopup",
    },
    "milking-cleaning-performance/cleaning-alarm-timeline/ldn-dropdown": {
        id: dataSourceIdMap["FMS_CleaningPerformance_CleaningAlarmTimeline_LdnDropdown"],
        name: "FMS_CleaningPerformance_CleaningAlarmTimeline_LdnDropdown",
    },
    "milking-cleaning-performance/cleaning-alarm-timeline/stacked-bar-chart": {
        id: dataSourceIdMap["FMS_CleaningPerformance_CleaningAlarmTimeline_StackedBarChart"],
        name: "FMS_CleaningPerformance_CleaningAlarmTimeline_StackedBarChart",
    },
    "milking-critical-alarms/critical-alarms-overview": {
        id: dataSourceIdMap["FMS_CriticalAlarms_CriticalAlarmsOverview"],
        name: "FMS_CriticalAlarms_CriticalAlarmsOverview",
    },
    "milking-critical-alarms/critical-alarms-timeline/ca-popup": {
        id: dataSourceIdMap["FMS_CriticalAlarms_CriticalAlarmsTimeline_CAPopup"],
        name: "FMS_CriticalAlarms_CriticalAlarmsTimeline_CAPopup",
    },
    "milking-critical-alarms/critical-alarms-timeline/stacked-bar-chart": {
        id: dataSourceIdMap["FMS_CriticalAlarms_CriticalAlarmsTimeline_StackedBarChart"],
        name: "FMS_CriticalAlarms_CriticalAlarmsTimeline_StackedBarChart",
    },
    "milking-critical-alarms/timeline-ldn-dropdown": {
        id: dataSourceIdMap["FMS_CriticalAlarms_CriticalAlarmsTimeline_DeviceDropdown"],
        name: "FMS_CriticalAlarms_CriticalAlarmsTimeline_DeviceDropdown",
    },
    "parts/decreased-usage/table": {
        id: dataSourceIdMap["PartsOverviewDecreasedUsage"],
        name: "PartsOverviewDecreasedUsage",
    },
    "parts/detailed-usage-other/table": {
        id: dataSourceIdMap["Parts_DetailedUsageOther_Table"],
        name: "Parts_DetailedUsageOther_Table",
    },
    "parts/detailed-usage-per-device-type/table": {
        id: dataSourceIdMap["Parts_DetailedUsagePerDeviceType_Table"],
        name: "Parts_DetailedUsagePerDeviceType_Table",
    },
    "parts/detailed-usage-total/table": {
        id: dataSourceIdMap["Parts_DetailedUsageTotal_Table"],
        name: "Parts_DetailedUsageTotal_Table",
    },
    "parts/devices-most-frequent-replacements/table": {
        id: dataSourceIdMap["Parts_DevicesMostFrequentReplacements_Table"],
        name: "Parts_DevicesMostFrequentReplacements_Table",
    },
    "parts/highest-part-users/table": {
        id: dataSourceIdMap["Parts_HighestPartUsers_Table"],
        name: "Parts_HighestPartUsers_Table",
    },
    "parts/increased-usage/table": {
        id: dataSourceIdMap["PartsOverviewIncreasedUsage"],
        name: "PartsOverviewIncreasedUsage",
    },
    "parts/list/table": {
        id: dataSourceIdMap["PartsOverviewPartsList"],
        name: "PartsOverviewPartsList",
    },
    "parts/overused-parts-vs-cluster/table": {
        id: dataSourceIdMap["PartsOverviewOverusedParts"],
        name: "PartsOverviewOverusedParts",
    },
    "parts/part-detail": {
        id: dataSourceIdMap["Parts_PartDetail"],
        name: "Parts_PartDetail",
    },
    "parts/part-usage": {
        id: dataSourceIdMap["Parts_PartUsage"],
        name: "Parts_PartUsage",
    },
    "parts/seasonal-usage-chart": {
        id: dataSourceIdMap["Parts_SeasonalUsageChart"],
        name: "Parts_SeasonalUsageChart",
    },
    "parts/service-history": {
        id: dataSourceIdMap["Parts_ServiceHistory"],
        name: "Parts_ServiceHistory",
    },
    "pms-to-be-done-soon": {
        id: dataSourceIdMap["PMsToBeDoneSoon"],
        name: "PMsToBeDoneSoon",
    },
    "pms-to-repair-ratio": {
        id: dataSourceIdMap["PMsOverdueRepairRatio"],
        name: "PMsOverdueRepairRatio",
    },
    "productive-time/chart": {
        id: dataSourceIdMap["ProductiveTime_Chart"],
        name: "ProductiveTime_Chart",
    },
    "repairs-per-astronaut/count-past12-months/evolution": {
        id: dataSourceIdMap["RepairsPerAstronaut_CountPast12Months_Evolution"],
        name: "RepairsPerAstronaut_CountPast12Months_Evolution",
    },
    "repairs-per-astronaut/installed-astronauts/customer": {
        id: dataSourceIdMap["RepairsPerAstronaut_InstalledAstronauts_Customer"],
        name: "RepairsPerAstronaut_InstalledAstronauts_Customer",
    },
    "repairs-per-astronaut/installed-astronauts/expanded": {
        id: dataSourceIdMap["RepairsPerAstronaut_InstalledAstronauts_Expanded"],
        name: "RepairsPerAstronaut_InstalledAstronauts_Expanded",
    },
    "repairs-per-astronaut/past12-months/kpi/evolution": {
        id: dataSourceIdMap["RepairsPerAstronaut_Past12Months_Kpi_Evolution"],
        name: "RepairsPerAstronaut_Past12Months_Kpi_Evolution",
    },
    "repairs-per-astronaut/service-history": {
        id: dataSourceIdMap["RepairsPerAstronaut_ServiceHistory"],
        name: "RepairsPerAstronaut_ServiceHistory",
    },
    "repeat-visit-cases/chart": {
        id: dataSourceIdMap["RepeatVisitCases_Chart"],
        name: "RepeatVisitCases_Chart",
    },
    "repeat-visit-cases/double-expanded-table/level1": {
        id: dataSourceIdMap["RepeatVisitCases_DoubleExpandedTable_Level1"],
        name: "RepeatVisitCases_DoubleExpandedTable_Level1",
    },
    "repeat-visit-rate/double-expanded-table/level1": {
        id: dataSourceIdMap["RepeatVisitRate_DoubleExpandedTable_Level1"],
        name: "RepeatVisitRate_DoubleExpandedTable_Level1",
    },
    "repeat-visit-rate/double-expanded-table/level2": {
        id: dataSourceIdMap["RepeatVisitRate_DoubleExpandedTable_Level2"],
        name: "RepeatVisitRate_DoubleExpandedTable_Level2",
    },
    "repeat-visit-rate/double-expanded-table/level3": {
        id: dataSourceIdMap["RepeatVisitRate_DoubleExpandedTable_Level3"],
        name: "RepeatVisitRate_DoubleExpandedTable_Level3",
    },
    "repeat-visit-rate/tip-for-development": {
        id: dataSourceIdMap["RepeatVisitRate_TipForDevelopment"],
        name: "RepeatVisitRate_TipForDevelopment",
    },
    "repeat-visit-rate/tip-for-development-breakdown": {
        id: dataSourceIdMap["RepeatVisitRate_TipForDevelopmentBreakdown"],
        name: "RepeatVisitRate_TipForDevelopmentBreakdown",
    },
    "search-customer": {
        id: dataSourceIdMap["SearchCustomer"],
        name: "SearchCustomer",
    },
    "search-device": {
        id: dataSourceIdMap["SearchDevice"],
        name: "SearchDevice",
    },
    "search-farm": {
        id: dataSourceIdMap["SearchFarm"],
        name: "SearchFarm",
    },
    "search-technician": {
        id: dataSourceIdMap["SearchTechnician"],
        name: "SearchTechnician",
    },
    "service-agreements-table/expanded": {
        id: dataSourceIdMap["ServiceAgreementsTable_Expanded"],
        name: "ServiceAgreementsTable_Expanded",
    },
    "service-agreements-table": {
        id: dataSourceIdMap["ServiceAgreementsTable"],
        name: "ServiceAgreementsTable",
    },
    "service-area-comparison-table": {
        id: dataSourceIdMap["ServiceAreaComparison_Table"],
        name: "ServiceAreaComparison_Table",
    },
    "service-area-insight-interaction-statistics/table": {
        id: dataSourceIdMap["ServiceAreaInsightInteractionStatistics_Table"],
        name: "ServiceAreaInsightInteractionStatistics_Table",
    },
    "service-area-list": {
        id: dataSourceIdMap["ServiceAreaList"],
        name: "ServiceAreaList",
    },
    "service-area-support/repeat-visit-statistics/line-chart": {
        id: dataSourceIdMap["RepeatVisitStatistics_LineChart"],
        name: "RepeatVisitStatistics_LineChart",
    },
    "service-area-support/repeat-visit-statistics/table": {
        id: dataSourceIdMap["RepeatVisitStatistics_Table"],
        name: "RepeatVisitStatistics_Table",
    },
    "service-history-customer": {
        id: dataSourceIdMap["ServiceHistoryCustomer"],
        name: "ServiceHistoryCustomer",
    },
    "service-history-detail-technician": {
        id: dataSourceIdMap["ServiceHistoryDetailTechnician"],
        name: "ServiceHistoryDetailTechnician",
    },
    "service-history-expanded-detail": {
        id: dataSourceIdMap["ServiceHistoryExpandedDetail"],
        name: "ServiceHistoryExpandedDetail",
    },
    "service-history-man-hours-high": {
        id: dataSourceIdMap["ServiceHistoryManHoursHigh"],
        name: "ServiceHistoryManHoursHigh",
    },
    "service-history-technician": {
        id: dataSourceIdMap["ServiceHistoryTechnician"],
        name: "ServiceHistoryTechnician",
    },
    "sm/installed-devices": {
        id: dataSourceIdMap["SM_InstalledDevices"],
        name: "SM_InstalledDevices",
    },
    "sm/pms-to-repair-ratio": {
        id: dataSourceIdMap["PMsToRepairRatio"],
        name: "PMsToRepairRatio",
    },
    "sm/service-cost-per-liter-milk": {
        id: dataSourceIdMap["SM_ServiceCostPerLiterMilk"],
        name: "SM_ServiceCostPerLiterMilk",
    },
    "software-version/current-version/table": {
        id: dataSourceIdMap["SoftwareVersion_CurrentVersion_Table"],
        name: "SoftwareVersion_CurrentVersion_Table",
    },
    "software-version/per-customer/table": {
        id: dataSourceIdMap["SoftwareVersion_PerCustomer_Table"],
        name: "SoftwareVersion_PerCustomer_Table",
    },
    "software-version/per-customer/table-expanded": {
        id: dataSourceIdMap["SoftwareVersion_PerCustomer_TableExpanded"],
        name: "SoftwareVersion_PerCustomer_TableExpanded",
    },
    "software-version/status/kpi": {
        id: dataSourceIdMap["SoftwareVersion_Status_KPI"],
        name: "SoftwareVersion_Status_KPI",
    },
    "strategic-overview/profitability-alerts-agreement-type/line-chart": {
        id: dataSourceIdMap["StrategicOverview_ProfitabilityAlertsAgreementType_LineChart"],
        name: "StrategicOverview_ProfitabilityAlertsAgreementType_LineChart",
    },
    "strategic-overview/profitability-alerts-agreement-type/table": {
        id: dataSourceIdMap["StrategicOverview_ProfitabilityAlertsAgreementType_Table"],
        name: "StrategicOverview_ProfitabilityAlertsAgreementType_Table",
    },
    "strategic-overview/profitability-alerts-device-type/line-chart": {
        id: dataSourceIdMap["StrategicOverview_ProfitabilityAlertsDeviceType_LineChart"],
        name: "StrategicOverview_ProfitabilityAlertsDeviceType_LineChart",
    },
    "strategic-overview/profitability-alerts-device-type/table": {
        id: dataSourceIdMap["StrategicOverview_ProfitabilityAlertsDeviceType_Table"],
        name: "StrategicOverview_ProfitabilityAlertsDeviceType_Table",
    },
    "strategic-overview/technician-certification-kpi/table": {
        id: dataSourceIdMap["StrategicOverview_TechnicianCertificationKpi_Table"],
        name: "StrategicOverview_TechnicianCertificationKpi_Table",
    },
    "take-off-reason/alerts": {
        id: dataSourceIdMap["TakeOffReason_Alerts"],
        name: "TakeOffReason_Alerts",
    },
    "take-off-reason/device/air-flow-per-teat/daily": {
        id: dataSourceIdMap["TakeOffReason_Device_AirFlowPerTeat_Daily"],
        name: "TakeOffReason_Device_AirFlowPerTeat_Daily",
    },
    "take-off-reason/device/end-of-milk-flow-per-teat/daily": {
        id: dataSourceIdMap["TakeOffReason_Device_EndOfMilkFlowPerTeat_Daily"],
        name: "TakeOffReason_Device_EndOfMilkFlowPerTeat_Daily",
    },
    "take-off-reason/device/list": {
        id: dataSourceIdMap["TakeOffReason_Device_List"],
        name: "TakeOffReason_Device_List",
    },
    "take-off-reason/device/types-distribution": {
        id: dataSourceIdMap["TakeOffReason_Device_TypesDistribution"],
        name: "TakeOffReason_Device_TypesDistribution",
    },
    "take-off-reason/types-distribution/daily": {
        id: dataSourceIdMap["TakeOffReason_TypesDistribution_Daily"],
        name: "TakeOffReason_TypesDistribution_Daily",
    },
    "take-off-reason/types-distribution": {
        id: dataSourceIdMap["TakeOffReason_TypesDistribution"],
        name: "TakeOffReason_TypesDistribution",
    },
    "tds/cow-match-liner-advice/chart": {
        id: dataSourceIdMap["TDS_CowMatchLinerAdvice_Chart"],
        name: "TDS_CowMatchLinerAdvice_Chart",
    },
    "tds/farm-list": {
        id: dataSourceIdMap["TDS_FarmList"],
        name: "TDS_FarmList",
    },
    "tds/liner-data-per-robot-overview": {
        id: dataSourceIdMap["TDS_LinerDataPerRobotOverview"],
        name: "TDS_LinerDataPerRobotOverview",
    },
    "tds/robot-teat-length-distribution/chart": {
        id: dataSourceIdMap["TDS_RobotTeatLengthDistribution_Chart"],
        name: "TDS_RobotTeatLengthDistribution_Chart",
    },
    "tds/robot-teat-width-distribution/chart": {
        id: dataSourceIdMap["TDS_CowTeatWidthDistributionPerRobot_Chart"],
        name: "TDS_CowTeatWidthDistributionPerRobot_Chart",
    },
    "tds/teat-width-measurement/table": {
        id: dataSourceIdMap["TDS_TeatWidthMeasurement_Table"],
        name: "TDS_TeatWidthMeasurement_Table",
    },
    "tds/year-week-list": {
        id: dataSourceIdMap["TDS_YearWeekSelect_Options"],
        name: "TDS_YearWeekSelect_Options",
    },
    "technician-details/certificates-expanded": {
        id: dataSourceIdMap["TechnicianCertificates"],
        name: "TechnicianCertificates",
    },
    "technician-details": {
        id: dataSourceIdMap["TechnicianDetails"],
        name: "TechnicianDetails",
    },
    "technicians-list": {
        id: dataSourceIdMap["TechniciansList"],
        name: "TechniciansList",
    },
    "vector/activity-timeline/alarms": {
        id: dataSourceIdMap["Vector_ActivityTimeline_Alarms"],
        name: "Vector_ActivityTimeline_Alarms",
    },
    "vector/activity-timeline/service-history": {
        id: dataSourceIdMap["Vector_ActivityTimeline_ServiceHistory"],
        name: "Vector_ActivityTimeline_ServiceHistory",
    },
    "vector-loading/avg-loading-speed-accuracy/table": {
        id: dataSourceIdMap["Vector_AvgLoadingSpeedAccuracy_Table"],
        name: "Vector_AvgLoadingSpeedAccuracy_Table",
    },
    "vector-loading/speed-accuracy-increase/table": {
        id: dataSourceIdMap["VectorLoading_SpeedAccuracyIncrease_Table"],
        name: "VectorLoading_SpeedAccuracyIncrease_Table",
    },
    "vector-system/components-table": {
        id: dataSourceIdMap["VectorSystem_ComponentsTable"],
        name: "VectorSystem_ComponentsTable",
    },
    "vector-system/device-details": {
        id: dataSourceIdMap["VectorSystem_DeviceDetails"],
        name: "VectorSystem_DeviceDetails",
    },
    "vector-system/device-status-table": {
        id: dataSourceIdMap["VectorSystem_DeviceStatusTable"],
        name: "VectorSystem_DeviceStatusTable",
    },
    "vector-system/service-history": {
        id: dataSourceIdMap["VectorSystem_ServiceHistory"],
        name: "VectorSystem_ServiceHistory",
    },
    "work-hours-breakdown": {
        id: dataSourceIdMap["WorkHoursBreakdown"],
        name: "WorkHoursBreakdown",
    },
    "work-overview": {
        id: dataSourceIdMap["WorkOverview"],
        name: "WorkOverview",
    },
    "work-overview-expanded-detail": {
        id: dataSourceIdMap["WorkOverviewExpandedDetail"],
        name: "WorkOverviewExpandedDetail",
    },
    "work-type-breakdown": {
        id: dataSourceIdMap["WorkTypeBreakdown"],
        name: "WorkTypeBreakdown",
    },
} satisfies Record<string, DataSourceRegistryRecord>;

type DataSourceRegistry = typeof dataSourceRegistry;
export type DataSourceRegistryPath = keyof DataSourceRegistry;

export const pathToNameMap: Record<DataSourceRegistryPath, DataSourceName> = Object.fromEntries(
    Object.entries(dataSourceRegistry).map(([path, value]) => [path, value.name])
) as Record<DataSourceRegistryPath, DataSourceName>;

export const nameToPathMap: Record<DataSourceName, DataSourceRegistryPath> = Object.fromEntries(
    Object.entries(dataSourceRegistry).map(([path, value]) => [value.name, path])
) as Record<DataSourceName, DataSourceRegistryPath>;
